import { axios } from "~/plugins/request";
import {findBasicConfigData} from "../../api/new-regulation/initialPlan";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUniversityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSpecialityList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getUniversityInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSpecialityUniversityInfo`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getSpecialityPackages({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/crmSpecialityPackage/packages`, {params}).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  saveScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getSchemeDetails({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSchemeInfo`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailsForEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSchemeInfoForEdit`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getChooseData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/crmSpecialityPackage/packagesSet`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  schemeCheck({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSchemeInfoCheck`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  copyScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/copyScheme`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  selectSchemeCondition({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectSchemeCondition`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  previewSpecialityAccord({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/previewSpecialityAccord`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  previewUniversityPurpose({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectUniviersityPurpose`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/findBasicConfigData`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/configPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  findSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/newPlan/selectSchemeList`, params).then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },

  saveForNewPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/saveForNewPlan`, params).then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },

  selectNewPlanSchemeInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectNewPlanSchemeInfo`, params).then(response => {
        resolve(response);
      })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectNewPlanSchemeInfoForEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/selectNewPlanSchemeInfoForEdit`, params).then(response => {
        resolve(response);
      })
        .catch(error => {
          reject(error);
        });
    });
  },

  exportZjData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/report/export/exportZJInfo",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  exportNewPlanSchemeInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/report/export/exportNewPlanSchemeInfo",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

};
